import React, { createContext, useState } from 'react'
import api from '../services/api'

type ContractProps = {
  created_by: string
  name: string
  version: string
  text: string
  type: string
}

type EditContractProps = {
  id: string
  created_by: string
  updated_at: string
  name: string
  version: string
  text: string
  type: string
}

type ContextProps = {
  editItem: ContractProps | null
  newContract: ContractProps | null
  startEditing: (item: ContractProps) => void
  stopEditing: () => void
  updateItem: (updatedItem: ContractProps) => void
  updateFile: (file: File) => void
  createItem: (createdItem: ContractProps) => void
  createContract: () => void
  sendUpdate: () => void
  deleteContract: () => void
}

export const ContextContracts = createContext<ContextProps | undefined>(
  undefined,
)

const ContextContractsProvider = (props) => {
  const [editItem, setEditItem] = useState<EditContractProps | null>(null)
  const [newContract, setNewContract] = useState<ContractProps | null>(null)
  const [contractUpload, setContractUpload] = useState<File | null>(null)

  const startEditing = (item: EditContractProps) => {
    setEditItem(item)
  }

  const stopEditing = () => {
    setEditItem(null)
    setContractUpload(null)
    setNewContract(null)
  }

  const updateItem = (updatedItem: EditContractProps) => {
    setEditItem(updatedItem)
  }

  const updateFile = (file: File) => {
    setContractUpload(file)
  }

  const sendUpdate = () => {
    try {
      if (editItem != null && editItem) {
        const newFormData = new FormData()
        newFormData.append('id', editItem.id)
        newFormData.append('name', editItem.name)
        // newFormData.append('created_by', editItem.created_by)
        newFormData.append('type', editItem.type)
        if (contractUpload instanceof File) {
          newFormData.append('file', contractUpload, contractUpload?.name)
        }
        newFormData.append('text', editItem.text)

        api
          .put('/v1/contract/update', newFormData)
          .then((res) => {
            console.log(res.data)
            setNewContract(null)
            setContractUpload(null)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const createItem = (createdItem: ContractProps) => {
    setNewContract(createdItem)
  }

  const createContract = () => {
    try {
      if (newContract != null && newContract) {
        const newFormData = new FormData()
        newFormData.append('created_by', newContract.created_by)
        newFormData.append('name', newContract.name)
        // newFormData.append('version', newContract.version)
        newFormData.append('text', newContract.text)
        newFormData.append('type', newContract.type)
        if (contractUpload instanceof File) {
          newFormData.append('file', contractUpload, contractUpload?.name)
        }
        const data = {}
        for (const [key, value] of newFormData.entries()) {
          data[key] = value
        }
        console.log(data)

        api
          .post('/v1/contract/create', newFormData)
          .then((res) => {
            console.log(res.data)
            setNewContract(null)
            setContractUpload(null)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const deleteContract = () => {
    try {
      if (editItem != null && editItem) {
        api
          .delete('/v1/contract/delete', {
            data: {
              id: editItem?.id,
            },
          })
          .then((res) => {
            console.log(res.data)
            setNewContract(null)
            setContractUpload(null)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const contextValue: ContextProps = {
    editItem,
    newContract,
    startEditing,
    stopEditing,
    updateItem,
    sendUpdate,
    updateFile,
    createItem,
    createContract,
    deleteContract,
  }

  return (
    <ContextContracts.Provider value={contextValue}>
      {props.children}
    </ContextContracts.Provider>
  )
}

export default ContextContractsProvider
